import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  > div:not(:first-child) {
    margin-bottom: 2rem;
  }
`
